import { render, staticRenderFns } from "./StudyView.vue?vue&type=template&id=6b7e871d&scoped=true"
import script from "./StudyView.vue?vue&type=script&lang=js"
export * from "./StudyView.vue?vue&type=script&lang=js"
import style0 from "./StudyView.vue?vue&type=style&index=0&id=6b7e871d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7e871d",
  null
  
)

export default component.exports